import { render, staticRenderFns } from "./dtl.vue?vue&type=template&id=5ca5a5f2&scoped=true"
import script from "./dtl.vue?vue&type=script&lang=js"
export * from "./dtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5a5f2",
  null
  
)

export default component.exports